import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import {
    createTemplateEmail,
    updateTemplateEmail,
    fetchTemplateAll,
    deleteTemplate,
    fetchEditTemplate,
    concernOptionList,

} from "@/services/emailTemplate";

@Module({
  namespaced: true
})
export default class emailTemplate extends VuexModule {
  // state
  fetchTemplateList = [];
  editTemplateData = {};
  concernOptionData = [];

  // Action

  @Action
  public async fetchTemplateAction() {
    try {
      const data = await fetchTemplateAll();
      this.context.commit("setTemplateList", data.data);
      return data.data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async editTemplate(payload) {
    try {
      const data = await fetchEditTemplate(payload);
      this.context.commit("setEditTemplate", data.data);
      return data.data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async deleteTemplate(payload) {
    try {
      const data = await deleteTemplate(payload);
      return data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async createEmailTemplate(payload) {
    try {
      const data = await createTemplateEmail(payload);
      return data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async updateEmailTemplate(payload) {
    try {
      const data = await updateTemplateEmail(payload);
      return data;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async fetchConcernList() {
    try {
      const data = await concernOptionList();
      this.context.commit("setConcernOption", data.data);
      return data.data;
    } catch (err) {
      throw err;
    }
  }

  @Mutation
  public setTemplateList(data: any) {
    this.fetchTemplateList = data;
  }

  @Mutation
  public setEditTemplate(data: any) {
    this.editTemplateData = data;
  }

  @Mutation
  public setConcernOption(data: any) {
    this.concernOptionData = data;
  }

  get GetFetchTemplateList() {
    return this.fetchTemplateList;
  }

  get GetEditTemplate() {
    return this.editTemplateData;
  }

  get GetconcernOptionData() {
    return this.concernOptionData;
  }
}